<template>
  <div>
    <div v-if="bannerDetails.svg">
      <img :src="svgSrc" :alt="bannerDetails.text">
    </div>
    <div v-else>
      <span
        class="pdp-text pdp-banner-content d-inline-block my-auto"
        :class="bannerDetails.text_color"
      >
        {{ bannerText }}
      </span>
      <TooltipIcon
        v-if="bannerDetails.tooltip"
        :tooltip-id="tooltipId"
        :tooltip-text="bannerDetails.tooltip"
        tooltip-type="deal_banner"
        class="d-inline-block my-auto ml-2"
      />
    </div>
  </div>
</template>

<script>
import moment from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import TooltipIcon from '../common/TooltipIcon.vue';
import SumoDaySvg from '../../../static/images/svg/sumo_day_2022.svg';

moment.extend(relativeTime);

export default {
  name: 'DealBannerContent',
  components: {
    TooltipIcon,
  },
  props: {
    bannerDetails: {
      type: Object,
      required: true,
    },
    tooltipId: {
      type: String,
      required: true,
    },
  },
  computed: {
    svgSrc() {
      if (this.bannerDetails.svg === 'sumo day') {
        return SumoDaySvg;
      }

      return null;
    },
  },
  created() {
    this.bannerText = this.bannerDetails?.text;
    if (this.bannerDetails?.text === 'Ending soon') {
      this.bannerText = `Offer ends ${moment(this.bannerDetails.endDate).fromNow()}`;
    }
  },
};
</script>

<style lang="scss" scoped>
  .pdp-banner-content {
    padding: 4px 0;
    font-weight: 500;
  }
</style>
